import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { companyInfo } from '../data/siteData';

export default function TakPage() {
  return (
    <>
      <SEO
        title="Tak for din henvendelse. | Hovendals"
        description="Vi har modtaget din besked og vender tilbage til dig hurtigst muligt."
      />

      <section className="py-24 md:py-32 bg-slate-50 min-h-[60vh] flex items-center">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <div className="w-20 h-20 rounded-full bg-emerald-100 text-emerald-600 mx-auto flex items-center justify-center text-3xl shadow-sm">
            <i className="fa-sharp fa-solid fa-check" aria-hidden="true"></i>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight">
            Tak for din henvendelse
          </h1>

          <p className="text-lg text-slate-600 max-w-xl mx-auto leading-relaxed">
            Vi har modtaget din besked og vender tilbage til dig hurtigst muligt.
          </p>

          <div className="pt-6 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="px-6 py-3.5 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all inline-flex items-center gap-2"
            >
              <i className="fa-sharp fa-solid fa-house" aria-hidden="true"></i>
              <span>Gå til forsiden</span>
            </Link>

            <a
              href={`tel:${companyInfo.phoneFormatted}`}
              className="px-6 py-3.5 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm shadow-sm transition-all inline-flex items-center gap-2"
            >
              <i className="fa-sharp fa-solid fa-phone text-[#004fa4]" aria-hidden="true"></i>
              <span>Ring til os på {companyInfo.phone}</span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
